import { useContext, useEffect, useState } from 'react'
import axios from 'axios'

const useProductData = (apiUrl, companyId, accessToken, productId, carInfo, vehicleIdentificationType, vehicleIdentification) => {
  const [productData, setProductData] = useState(null)
  const [isLoading, setIsLoading] = useState(true)
  const [error, setError] = useState(null)

  useEffect(() => {
    if (!productId || !carInfo || !vehicleIdentificationType || !vehicleIdentification) {
      return
    }

    const getProduct = async () => {
      const url = `${apiUrl}/FinancialManagement/Company/${companyId}/Nordania/Product/${productId}`

      const queryParams = {
        vehiclePrice: carInfo?.price,
        firstRegistrationDate: carInfo?.vehicleFirstRegistrationDate.split('-').reverse().join('-') || '2023-01-01',
        vehicleIdentificationType,
        vehicleIdentification
      }

      const config = {
        headers: {
          'Accept': 'application/json',
          'Authorization': `Bearer ${accessToken}`
        },
        params: queryParams
      }

      try {
        setIsLoading(true)
        const response = await axios.get(url, config)
        setProductData(response.data)
      } catch (error) {
        console.error('HTTP Error:', error.message)
        setError(error)
      } finally {
        setIsLoading(false)
      }
    }

    getProduct()
  }, [companyId, accessToken, productId, carInfo, vehicleIdentificationType, vehicleIdentification])

  return {
    productData,
    productDataIsLoading: isLoading,
    productDataError: error
  }
}

export default useProductData
